class BESSAppCouncilAPIService extends BESSAppAPIServiceBase {

    constructor(parent) {
        super(parent, 'council/');
        this.context.council_id = $('.app-selected-council').attr('data-council-id');
    }

    removeCouncilUser(userId, onSuccess, onFailure = null) {
        this._post('remove-user', {
            data: {
                'remove_user_id': userId,
            },
            onResult: onSuccess,
            onFailure: onFailure,
        });
    }

    lookupAddCouncilUserEmail(match, onSuccess, onFailure = null) {
        this._post('lookup-add-user', {
            data: {
                'match': match,
            },
            onResult: onSuccess,
            onFailure: onFailure,
        });
    }

    addCouncilUser(userId, onSuccess, onFailure = null) {
        this._post('add-user', {
            data: {
                'add_user_id': userId,
            },
            onResult: onSuccess,
            onFailure: onFailure,
        });
    }

    updateCouncilAttributes(
        website,
        esdLocalPlanningPolicy,
        esdPolicyUrl,
        elevatedTargetsCouncil,
        onSuccess,
        onFailure = null) {
        this._post('update-attributes', {
            data: {
                'website': website,
                'esd_local_planning_policy': esdLocalPlanningPolicy,
                'esd_policy_url': esdPolicyUrl,
                'elevated_targets_council': elevatedTargetsCouncil,
            },
            onResult: onSuccess,
            onFailure: onFailure,
        })
    }

}